export const rules = {
    reason: [{
        required: true,
        message: 'Пожалуйста, введите название ',
        trigger: 'change'
    },]
};
